var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    id: "arrow",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.894 23.726 7.652-7.016a.94.94 0 0 0 0-1.414c-.012-.01-.028-.014-.04-.024l-7.612-7a1.176 1.176 0 0 0-1.552 0c-.002.004-.004.01-.008.014A.951.951 0 0 0 12 9v14c0 .286.136.54.346.722l-.004.004c.43.392 1.124.392 1.552 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.66221ef19fb526742257f4a6b703763e.svg";
export { ForwardRef as ReactComponent };